<div class="page-content-admin">
  <div class="body">
    <ng-content></ng-content>
  </div>
</div>

<!-- <ng-template [ngxPermissionsExcept]="['ADMIN']">
  <div class="page-content-user">
    <div class="body">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template> -->